// index.js
import Footer from './Footer';

export default Footer;



// WEBPACK FOOTER //
// ./src/comps/Footer/index.js